import { api } from "./api.service";

export type AuditAction =
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "LOGIN"
  | "LOGOUT"
  | "PAYMENT"
  | "CANCEL"
  | "STATUS_CHANGE";

export type AuditOrigin = "WEB" | "MOBILE" | "API" | "WEBHOOK" | "CRON" | "SYSTEM";

export interface AuditLogItem {
  id: string;
  userId?: string | null;
  userRole?: string | null;
  // Nome do usuário afetado (quando o backend enviar). Usado apenas para exibição.
  userName?: string | null;
  action: AuditAction;
  description?: string | null;
  entity?: string | null;
  entityId?: string | null;
  oldValue?: any;
  newValue?: any;
  origin?: AuditOrigin | null;
  ipAddress?: string | null;
  userAgent?: string | null;
  success: boolean;
  errorMessage?: string | null;
  createdAt: string;
}

export interface AuditLogsPagination {
  page: number;
  perPage: number;
  totalItems: number;
  totalPages: number;
}

export interface ListAuditLogsResponse {
  pagination: AuditLogsPagination;
  items: AuditLogItem[];
}

export interface ListAuditLogsParams {
  page?: number;
  perPage?: number;
  action?: AuditAction;
  origin?: AuditOrigin;
  entity?: string;
  entityId?: string;
  userId?: string;
  success?: boolean;
  from?: string; // ISO/date
  to?: string; // ISO/date
  q?: string;
}

export async function listAuditLogs(params: ListAuditLogsParams): Promise<ListAuditLogsResponse> {
  const { data } = await api.get<ListAuditLogsResponse>("/audit-logs", {
    params,
    // Se você quiser marcar origem como WEB no backend, envie este header.
    headers: {
      "x-origin": "WEB",
    },
  });

  return data;
}
